import type { ReactNode } from "react";

import clsx from "clsx";

import { ArrowDownIcon } from "../../icons/arrow-down";
import { Button } from "../button";

import styles from "./filter-button.module.css";

type FilterButtonProps = {
	children: ReactNode;
	isOpen: boolean;
	placeholder: string;
	selected: null | string;
};

export function FilterButton({
	children,
	isOpen,
	placeholder,
	selected,
}: FilterButtonProps): ReactNode {
	return (
		<Button aria-label={placeholder} className={styles.filterButton} variant="secondary">
			{children}
			{selected ? (
				<span className={styles.closeBtnPlaceholder} />
			) : (
				<ArrowDownIcon className={clsx(isOpen && styles.openArrow, styles.arrow)} />
			)}
		</Button>
	);
}
